module.exports = __webpack_public_path__ + "static/media/software-cube.ea13edcd.svg";